module.exports = __webpack_public_path__ + "static/media/PlusBlueIcon.e41fe6ab.svg";